import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/learn";
import { Card } from "antd";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

class RightNews extends Component {

  componentDidMount() {
    this.props.learnRec();
  }

  render() {
    let { learnRec } = this.props.learn;
    return (
      <div className="right">
        <Card title="推荐文章" size="small">
          <ul className="topicrec">
            {learnRec
              ? learnRec.map(item => (
                  <li key={item.learn_id}>
                    <Link to={`/read/${item.learn_id}`}>
                      <span>{item.learn_title.length>14?item.learn_title.slice(0,14)+'...':item.learn_title}</span>
                      <span>{moment(item.learn_auto_addtime).format('YY-MM-DD')}</span>
                    </Link>
                  </li>
                ))
              : null}
          </ul>
        </Card>
      </div>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
) (RightNews);
